import React, { useEffect, useState } from "react";
import { AlertInfo } from "../../../common/Alert";
import BootstrapTable from "react-bootstrap-table-next";
import { BsTrash } from "react-icons/bs";
import { MdOutlineModeEdit, MdOutlineTimer, MdUnarchive } from "react-icons/md";
import TableSkeleton from "../../../common/TableSkeleton";
import { NavLink } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import { useGetListAdminUserQuery } from "../../../../utils/api/user/user.api";
import { IUser } from "../../../../utils/api/user/user.type";
import { CustomPagination } from "../../../common/CustomPagination";
import { UseArchiveAdmin, UseDeleteAdmin } from "../form/useCrudAdminForm";
import { BiArchiveIn } from "react-icons/bi";

const BtnArchive = ({ item }: { item: IUser }) => {
  const onArchive = UseArchiveAdmin(item);

  return (
    <button
      className="btn with-tooltip btn-action-icon-delete"
      data-tooltip-content={item?.is_archive ? "Désarchiver" : "Archiver"}
      style={{ color: "#E53E3E" }}
      onClick={onArchive}
    >
      {/* <BsTrash /> */}
      {item?.is_archive ? <MdUnarchive /> : <BiArchiveIn />}
    </button>
  );
};

const BtnDelete = ({ slug }) => {
  const onDelete = UseDeleteAdmin(slug);
  return (
    <button
      className="btn with-tooltip btn-action-icon-delete"
      data-tooltip-content={"Supprimer"}
      style={{ color: "#E53E3E" }}
      onClick={onDelete}
    >
      <BsTrash />
    </button>
  );
};

function AdministrateurTable() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const { data = { results: [], count: 0 }, isLoading,refetch } =
    useGetListAdminUserQuery({});
  useEffect(() => {
    if (!isLoading) refetch();
  }, []);

  const actionFormatter = (cell: string, row: IUser) => {
    return (
      <>
        <div className="d-flex justify-content-center gap-3">
          <div className="container-btn-action-icon-modal">
            <NavLink
              to={`/admin/parametres/liste-admins/${cell}`}
              className="btn btn-action-icon-edit with-tooltip"
              data-tooltip-content="Voir"
              state={row}
            >
              <AiOutlineEye />
            </NavLink>
          </div>
          <div className="container-btn-action-icon-modal">
            <NavLink
              to={`/admin/parametres/modifier-un-admin/${cell}`}
              className="btn btn-action-icon-edit with-tooltip"
              data-tooltip-content="Modifier"
              state={row}
            >
              <MdOutlineModeEdit />
            </NavLink>
          </div>
          <div className="container-btn-action-icon-modal">
            <BtnArchive item={row} />
          </div>
          <div className="container-btn-action-icon-modal">
            <BtnDelete slug={cell} />
          </div>
        </div>
      </>
    );
  };

  const columns = [
    {
      dataField: "prenom",
      text: `Nom`,
      formatter: (cell: string, row: IUser) => cell + " " + row?.nom,
    },
    {
      dataField: "email",
      text: "Adresse mail",
    },
    {
      dataField: "telephone",
      text: "Numéro de téléphone",
    },
    {
      dataField: "slug",
      text: "Action",
      formatter: actionFormatter,
    },
  ];

  return (
    <>
      {isLoading && <TableSkeleton headers={columns} />}
      {!isLoading && (
        <>
          <BootstrapTable
            keyField="id"
            data={data?.results}
            columns={columns}
            condensed
            hover
            wrapperClasses="table-responsive admin-table"
            noDataIndication={() => (
              <AlertInfo message="Aucune donnée trouvéé" />
            )}
          />
          <div className="custom-pagination-container">
            <CustomPagination
              nbPages={data?.count}
              page={page}
              onChange={(page, perPage) => {
                setLimit(perPage);
                setPage(page);
              }}
              perPage={limit}
            />
          </div>
        </>
      )}
    </>
  );
}

export default AdministrateurTable;
